import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2, Mail, Radar, Briefcase } from "lucide-react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { useT } from "@/i18n";
import { useNoIndex } from "@/lib/noIndex";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AreaRiservata() {
  const t = useT();
  const [state, setState] = useState("idle");
  const [comp, setComp] = useState("idle");
  const [jobs, setJobs] = useState("idle");
  useNoIndex();
  const sendJobs = async () => {
    setJobs("busy");
    try {
      await axios.post(`${API}/jobs/request`);
      setJobs("sent");
    } catch (err) {
      setJobs("idle");
      toast.error(err?.response?.status === 429 ? t("form.err429", "Troppe richieste, riprova più tardi.") : t("res.err", "Invio non riuscito, riprova tra qualche minuto."));
    }
  };
  const sendComp = async () => {
    setComp("busy");
    try {
      await axios.post(`${API}/competitors/request`);
      setComp("sent");
      toast.success(t("comp.ok", "Fatto: il report sui concorrenti arriva nella tua casella email tra un minuto."));
    } catch (err) {
      setComp("idle");
      toast.error(err?.response?.status === 429 ? t("form.err429", "Troppe richieste, riprova più tardi.") : t("res.err", "Invio non riuscito, riprova tra qualche minuto."));
    }
  };
  const send = async () => {
    setState("busy");
    try {
      await axios.post(`${API}/contacts-export/request`);
      setState("sent");
      toast.success(t("res.ok", "Fatto: l'Excel dei contatti è in arrivo nella tua casella email."));
    } catch (err) {
      setState("idle");
      toast.error(err?.response?.status === 429 ? t("form.err429", "Troppe richieste, riprova più tardi.") : t("res.err", "Invio non riuscito, riprova tra qualche minuto."));
    }
  };
  return (
    <div className="min-h-screen bg-[#121110] text-[#F3EFE6]" data-testid="reserved-page">
      <Nav />
      <main className="mx-auto max-w-3xl px-5 pb-28 pt-40 sm:px-8">
        <FileSpreadsheet className="h-9 w-9 text-[#D98A52]" />
        <h1 className="mt-6 font-display text-4xl font-bold tracking-tight sm:text-5xl">{t("res.h", "Area riservata")}</h1>
        <p className="mt-6 text-base leading-relaxed text-[#D6D0C4] sm:text-lg">{t("res.p", "Premi il pulsante per ricevere subito all'email aziendale l'Excel aggiornato di tutti i contatti che hanno scaricato schede tecniche e calcoli. Il file arriva solo all'indirizzo dell'azienda: da questa pagina nessuno può vedere i dati.")}</p>
        <button onClick={send} disabled={state === "busy"} className="btn-amber mt-10 disabled:opacity-60" data-testid="reserved-send-excel">
          {state === "busy" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} {t("res.btn", "Inviami l'Excel dei contatti")}
        </button>
        {state === "sent" && <p className="mt-6 text-sm text-[#A8C98A]" data-testid="reserved-sent">{t("res.sent", "Email inviata. Il link per scaricare l'Excel vale 30 giorni.")}</p>}
        <section className="mt-16 border-t border-white/10 pt-12" data-testid="reserved-competitors">
          <Radar className="h-9 w-9 text-[#D98A52]" />
          <h2 className="mt-5 font-display text-2xl font-bold tracking-tight sm:text-3xl">{t("comp.h", "Siti concorrenti")}</h2>
          <p className="mt-4 text-base leading-relaxed text-[#D6D0C4]">{t("comp.resP", "Ogni lunedì ricevi per email cosa è cambiato sui siti dei concorrenti. Premi il pulsante per riceverlo subito, con il link per aggiungere o togliere siti.")}</p>
          <button onClick={sendComp} disabled={comp === "busy"} className="btn-amber mt-8 disabled:opacity-60" data-testid="reserved-send-competitors">
            {comp === "busy" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} {t("comp.btn", "Inviami il report concorrenti")}
          </button>
          {comp === "sent" && <p className="mt-6 text-sm text-[#A8C98A]" data-testid="reserved-competitors-sent">{t("comp.sent", "Report in arrivo su info@emmaindustrie.it.")}</p>}
        </section>
        <section className="mt-16 border-t border-white/10 pt-12" data-testid="reserved-jobs">
          <Briefcase className="h-9 w-9 text-[#D98A52]" />
          <h2 className="mt-5 font-display text-2xl font-bold tracking-tight sm:text-3xl">{t("jobs.resH", "Posizioni aperte")}</h2>
          <p className="mt-4 text-base leading-relaxed text-[#D6D0C4]">{t("jobs.resP", "Ricevi per email il link per aggiungere, modificare o chiudere le posizioni mostrate nella pagina Lavora con noi.")}</p>
          <button onClick={sendJobs} disabled={jobs === "busy"} className="btn-amber mt-8 disabled:opacity-60" data-testid="reserved-send-jobs">
            {jobs === "busy" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} {t("jobs.resBtn", "Inviami il link per le posizioni")}
          </button>
          {jobs === "sent" && <p className="mt-6 text-sm text-[#A8C98A]" data-testid="reserved-jobs-sent">{t("jobs.resSent", "Link in arrivo su info@emmaindustrie.it.")}</p>}
        </section>
      </main>
      <Footer />
    </div>
  );
}
